import { cn } from "@/utils/cn";

interface CardActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  editLabel?: string;
  deleteLabel?: string;
  className?: string;
}

/**
 * Groupe d'actions compact (Modifier / Supprimer) pour les cartes.
 * Boutons icônes avec infobulle pour rester lisibles et compacts sur mobile,
 * sans provoquer de débordement horizontal. Chaque action n'apparaît que si
 * le gestionnaire correspondant est fourni (et donc autorisé).
 */
export default function CardActions({
  onEdit,
  onDelete,
  editLabel = "Modifier",
  deleteLabel = "Supprimer",
  className,
}: CardActionsProps) {
  if (!onEdit && !onDelete) return null;

  return (
    <div className={cn("flex shrink-0 items-center gap-1.5", className)}>
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          title={editLabel}
          aria-label={editLabel}
          className="inline-flex h-9 w-9 items-center justify-center whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 text-foreground-700 transition-colors hover:border-foreground-300 hover:bg-background-100 cursor-pointer"
        >
          <i className="ri-edit-line text-base" aria-hidden="true" />
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          onClick={onDelete}
          title={deleteLabel}
          aria-label={deleteLabel}
          className="inline-flex h-9 w-9 items-center justify-center whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 text-primary-700 transition-colors hover:border-primary-200 hover:bg-primary-50 cursor-pointer"
        >
          <i className="ri-delete-bin-line text-base" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}